import { QuestionTextField, QuestionDropDownField, QuestionGiinField, QuestionStockMarketAutocompleteField } from 'components/Questionnaires/fields';
import { QuestionAddressBlock, QuestionTaxResidenceBlock, QuestionBlockRepeater, QuestionRepeater, QuestionSignerBlock } from 'components/Questionnaires/blocks';
import { requiredValidator, lengthValidator } from 'components/Questionnaires/validators';
import { incorporationCountryBlock } from './blocks/blocks';

const crsE = {
  blocks: [
    {
      id: 'name',
      title: 'questionnaire.crs.e.name',
      component: undefined, // Component for Block
      visible: true,
      questions: [
        {
          id: 'name',
          label: 'questionnaire.crs.e.name.label',
          component: QuestionTextField,
          info: {
            instructions: 'questionnaire.crs.e.name.info'
          },
          visible: true,
          lockGroup: 'name',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.crs.e.name.errorMessage' }
            ]
          }
        },
      ]
    },
    incorporationCountryBlock(),
    {
      id: 'address',
      title: 'questionnaire.address',
      component: QuestionAddressBlock,
      info: {
        instructions: 'questionnaire.address.1.info'
      },
      visible: true,
      lockGroup: 'permanentAddress',
    },
    {
      id: 'mailingAddress',
      title: 'questionnaire.mailingAddress',
      component: QuestionAddressBlock,
      componentProps: {
        line1Label: 'questionnaire.mailingAddress.1.label',
        optional: true
      },
      info: {
        instructions: 'questionnaire.mailingAddress.1.info'
      },
      visible: true,
      linkBlock: true,
      lockGroup: 'mailingAddress',
    },
    {
      id: 'entityType',
      title: 'questionnaire.crs.e.entityType',
      component: undefined, // Component for Block
      visible: true,
      questions: [
        {
          id: 'type',
          label: 'questionnaire.crs.e.entityType.label',
          component: QuestionDropDownField,
          componentProps: {
            items: 'questionnaire.crs.e.entityTypes'
          },
          info: {
            instructions: 'questionnaire.crs.e.entityType.info'
          },
          visible: true,
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.crs.e.entityType.errorMessage' }
            ]
          }
        },
        {
          id: 'fiType',
          label: 'questionnaire.crs.e.fiType.label',
          component: QuestionDropDownField,
          componentProps: {
            items: 'questionnaire.crs.e.fiTypes'
          },
          info: {
            instructions: 'questionnaire.crs.e.fiType.info'
          },
          visible: (bAnswers, qAnswers, preQualAnswers) => bAnswers?.type === 'FinancialInstitution',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.crs.e.fiType.errorMessage' }
            ]
          }
        },
        {
          id: 'activeNffeType',
          label: 'questionnaire.crs.e.activeNffeType.label',
          component: QuestionDropDownField,
          componentProps: {
            items: 'questionnaire.crs.e.activeNffeTypes.items'
          },
          visible: (bAnswers, qAnswers, preQualAnswers) => bAnswers?.type === 'ActiveNFE',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.crs.e.activeNffeType.errorMessage' }
            ]
          }
        },
        {
          id: 'securitiesMarket',
          label: 'questionnaire.ch4.publiclyTradedNffe.securityMarket.label',
          component: QuestionStockMarketAutocompleteField,
          visible: (bAnswers, qAnswers, preQualAnswers) => bAnswers?.type === 'ActiveNFE' && bAnswers?.activeNffeType === 'RegularlyTradedCorporation',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.crs.e.securitiesMarket.errorMessage' }
            ]
          }
        },
        {
          id: 'relatedEntity',
          label: 'questionnaire.crs.e.relatedEntity.label',
          component: QuestionTextField,
          info: {
            instructions: 'questionnaire.crs.e.relatedEntity.info'
          },
          visible: (bAnswers, qAnswers, preQualAnswers) => bAnswers?.type === 'ActiveNFE' && bAnswers?.activeNffeType === 'RelatedEntity',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.crs.e.relatedEntity.errorMessage' }
            ]
          }
        },
      ]
    },
    {
      id: 'giin',
      title: 'questionnaire.giin',
      component: undefined, // Component for Block
      info: {
        instructions: 'questionnaire.giin.info'
      },
      visible: (qAnswers, preQualAnswers) => qAnswers?.entityType?.type === 'FinancialInstitution',
      questions: [
        {
          id: 'value',
          label: 'questionnaire.giin.label',
          component: QuestionGiinField,
          componentProps: {
            length: 16
          },
          visible: true,
          validation: {
            conditions: [
              { condition: lengthValidator, message: 'questionnaire.giin.lengthErrorMessage' }
            ]
          }
        },
      ]
    },
    {
      id: 'controllingPersons',
      title: 'questionnaire.crs.e.controllingPersons',
      component: QuestionRepeater, // Component for Block
      visible: (qAnswers, preQualAnswers) => qAnswers?.entityType?.type === 'PassiveNFE' || qAnswers?.entityType?.fiType === 'InvestmentEntity',
      question: {
        id: 'name',
        label: 'questionnaire.crs.e.cpName.label',
        component: QuestionTextField,
        info: {
          instructions: 'questionnaire.crs.e.cpName.info'
        },
        visible: true,
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.crs.e.cpName.errorMessage' }
          ]
        }
      },
      minSize: 1,
      maxSize: 3,
    },
    {
      id: 'taxResidences',
      title: 'questionnaire.taxResidences',
      component: QuestionBlockRepeater,
      componentProps: {
        collapsible: true
      },
      repeatBlock: {
        id: 'taxResidence',
        title: 'questionnaire.taxResidence.additional',
        component: QuestionTaxResidenceBlock,
      },
      minSize: 1,
      maxSize: 3,
      addText: 'questionnaire.taxResidences.addLabel',
      visible: true,
    },
    {
      id: 'signer',
      title: 'questionnaire.signer',
      component: QuestionSignerBlock,
      componentProps: {
        entityOnly: true
      },
      visible: true
    },
  ]
};

export default crsE;
